import { API_BASE_URL } from '@synergy/config';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch } from '../../store/store';
import { SearchHistoryApi } from '../api/search-history-api';

const api = new SearchHistoryApi(API_BASE_URL);

export const searchHistoryReceived = createAction<string[]>('search-history/loaded');
export const searchHistoryCleared = createAction<void>('search-history/cleared');
export const searchHistoryAdded = createAction<string>('search-history/added');

export const fetchSearchHistory = () => async (dispatch: AppDispatch) => {
    const response = await api.getUserSearchHistory();
    if (response.success) {
        dispatch(searchHistoryReceived(response.result));
    }
    // We don't show an error if failed - just don't display search history
};

export const clearSearchHistory = () => async (dispatch: AppDispatch) => {
    const response = await api.clearUserSearchHistory();
    if (response.success) {
        dispatch(searchHistoryCleared());
    }
    // We don't show an error if failed - just don't clear the search history
};
